import { FaPlus, FaTrashAlt } from "react-icons/fa";
import { useDndMonitor, useDroppable } from "@dnd-kit/core";
import Sticky from "./Sticky";
import React from "react";
import { Button } from "@/components/ui/button";
import { getStickiesErrorMessage } from "./stickiesRpc";
import { useStickies } from "./useStickies";

interface StickiesOriginProps {
  weekSelected: number;
  yearSelected: number;
}

const StickiesOrigin = ({
  weekSelected,
  yearSelected,
}: StickiesOriginProps) => {
  const { setNodeRef } = useDroppable({ id: "stickiesOrigin" });
  const [isDragging, setIsDragging] = React.useState(false);
  const stickyState = useStickies({ year: yearSelected, week: weekSelected });

  useDndMonitor({
    onDragStart: () => {
      setIsDragging(true);
    },
    onDragEnd: (event) => {
      setIsDragging(false);
      const { over } = event;
      if (over) {
        if (over.id === "stickiesOrigin") {
          const id = event.active.id;
          if (typeof id !== "string") return;
          const stickyId = Number(id.slice("sticky-".length));
          stickyState.archiveSticky(stickyId).catch(() => {});
        }
      }
    },
  });

  const handleCreateSticky = () => {
    stickyState
      .createSticky({
        content: "Note",
        year: yearSelected,
        week: weekSelected,
        offsetX: 1,
        offsetY: 50,
        anchorId: "stickiesOrigin",
        positionMode: "pixel",
        relativeX: null,
        relativeY: null,
      })
      .catch(() => {});
  };

  const error = stickyState.error ?? stickyState.mutationError;
  return (
    <>
      {isDragging ? (
        <div
          className="bg-red-500 w-52 h-6 flex justify-center items-center mx-2 cursor-pointer"
          id="stickiesOrigin"
          ref={setNodeRef}
          // @ts-ignore anchorName pas encore dans le d.ts
          style={{ anchorName: "--stickiesOrigin" }}
        >
          <FaTrashAlt color="white" />
        </div>
      ) : (
        <Button
          className="bg-yellow-200 text-black hover:bg-yellow-400"
          id="stickiesOrigin"
          ref={setNodeRef}
          onClick={handleCreateSticky}
          size="icon-sm"
          variant="secondary"
          title="Créer une note"
          disabled={!stickyState.isReady || stickyState.isMutating}
          // @ts-ignore anchorName pas encore dans le d.ts
          style={{ anchorName: "--stickiesOrigin" }}
        >
          <FaPlus color="black" />
        </Button>
      )}
      {error ? (
        <div className="mx-2 text-sm text-red-700">
          {getStickiesErrorMessage(error)}
        </div>
      ) : null}
      {stickyState.stickies.map((sticky) => (
        <Sticky
          key={sticky.id}
          id={sticky.id}
          anchorId={sticky.anchorId}
          message={sticky.content}
          initialX={sticky.offsetX}
          initialY={sticky.offsetY}
          positionMode={sticky.positionMode}
          relativeX={sticky.relativeX}
          relativeY={sticky.relativeY}
          isMutating={stickyState.isMutating}
          onUpdate={stickyState.updateSticky}
        />
      ))}
    </>
  );
};

export default StickiesOrigin;
